/*
 * @Author: chenkailun
 * @Date: 2024-03-20 13:11:51
 * @LastEditors: chenkailun
 * @LastEditTime: 2024-09-02 17:54:20
 * @Description: 
 * @FilePath: \solarbiolite\src\store\modules\region.js
 */
import { regionList } from '../../api/region'

// initial state
const state = {
  items: [],
}

// mutations
const mutations = {
  saveRegionItems(state, items) {
    state.items = items
  },
  clearRegionItems(state) {
    state.item = []
  },
}

// actions
const actions = {
  fetchRegions({ commit, state }) {
    regionList().then((response) => {
      if (response.regions) {
        commit('saveRegionItems', response.regions)
      }
    }, (error) => {
    }
    )
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/region.js